export enum AdminFeatureEnum {
  DIGITAL_SHARING = "digital_sharing",
  EXTENDED_STORAGE = "extended_storage",
  WHATSAPP_SHARING = "whatsapp_sharing",
  /** When enabled, the Patient History column may be shown on case listings (subject to user table layout). */
  SHOW_PATIENT_HISTORY = "show_patient_history",
  CASE_OPENED = "case_opened",
  DOCTOR_REASSIGN = "doctor_reassign",
  SHOW_REPORTED_TIME = "show_reported_time",
  VIEWER_LOAD_ALL_SERIES = "viewer_load_all_series",
  VOICE_TO_TEXT = "voice_to_text",
  AI_REPORTING = "ai_reporting",
  SHARED_LINK_DOWNLOAD_ZIP = "shared_link_download_zip",
  TINYMCE = "tinymce",
  REPORT_EDIT_FULL_SCREEN_DEFAULT = "report_edit_full_screen_default",
  ACQUISITION_DATE = "acquisition_date",
  SCANCENTER_SHOW_REPORTED_DOCTOR = "scancenter_show_reported_doctor",
  REPORT_LOCK = "report_lock",
  AUTO_SAVE = "auto_save",
  EXPORT_IMAGE_ZIP = "export_image_zip",
  COSIGN = "cosign",
}
